import api from "./api/api";

const GetAllCEPs = {
  listCep: async (cep:any) => {
    try {
      const res = await api.get(`/cep/${cep}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default GetAllCEPs;
